import {
    Navigate,
    useLocation
} from "react-router-dom"
import { getAuthUserToken } from "../../../store/auth-actions";
import InitialLoading from "./InitialLoading";

const ProtectedRoute = ({ user, children }) => {
    const location = useLocation();
    const token = getAuthUserToken(); // Synchronous check

    // No token means not logged in
    if (!token) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    // User not loaded yet? Still wait instead of redirecting
    if (!user) {
        return <InitialLoading message="Authenticating..." />;
    }

    return children;
};
export default ProtectedRoute